import Vue from "vue";
import moment from "moment";
import Cookies from "js-cookie";
import i18n from "@/i18n";

// ==========================
// 🌍 Helper: current locale
// ==========================
const getCurrentLocale = () => {
  const cookieLang = Cookies.get("lang");
  return cookieLang || i18n.locale || "fr";
};

// ==========================
// 🗓️ Global Filters
// ==========================

// Format full date (LL)
Vue.filter("formatDate", (value) => {
  if (!value) return "";
  const locale = getCurrentLocale();
  return moment(value).locale(locale).format("LL");
});

// Old moment filter (optional – keep only if still used)
Vue.filter("momentOld", (value, formatType = "fromNow") => {
  if (!value) return "";
  const locale = getCurrentLocale();
  const m = moment(value).locale(locale);

  return formatType === "fromNow"
    ? m.fromNow()
    : m.format(formatType);
});

// Smart moment filter (fromNow < 30 days)
Vue.filter(
  "moment",
  (value, formatType = "fromNow", fallbackFormat = "DD-MM-YYYY") => {
    if (!value) return "";

    const locale = getCurrentLocale();
    const m = moment(value).locale(locale);

    const daysDiff = moment().diff(m, "days");

    // Use fromNow only if less than 30 days
    if (formatType === "fromNow" && daysDiff < 30) {
      return m.fromNow();
    }

    // Otherwise use formatted date
    return m.format(
      formatType === "fromNow" ? fallbackFormat : formatType
    );
  }
);
